import { render, staticRenderFns } from "./ReservationFooter.vue?vue&type=template&id=30685cad"
import script from "./ReservationFooter.vue?vue&type=script&lang=ts"
export * from "./ReservationFooter.vue?vue&type=script&lang=ts"
import style0 from "./ReservationFooter.vue?vue&type=style&index=0&id=30685cad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports